var React = require('react');
var DefaultLayout = require('./common/layout');
import { Form, FormGroup, Col, ControlLabel, Button } from 'react-bootstrap';
import { CenteredDiv } from './common/basic';
import { FControl, CheckBox } from './common/forms';
import '../public/less/login.less';
import axios from 'axios';
var validator = require('validator');

const loginForm = class Devices extends React.Component {
    constructor(props) {
        super(props);

        this.submitForm = this.submitForm.bind(this);

        var errorMsg = "";
        if (this.props.location.query.m == "used")
            errorMsg = "Password was used before, please choose another password.";
        else if (this.props.location.query.m == "error")
            errorMsg = "An error occured, please try again.";
        else if (this.props.location.query.m == "passwordNotInFormat")
            errorMsg = "Password not in correct format.";

        this.state = {
            errorMsg: errorMsg
        };
    }

    submitForm(evt) {
        var errorMsg = "";
        if (this._password.value != this._confirm_password.value) {
            errorMsg = "Passwords doesn't match";
        }
        else {
            if (!validator.isLength(this._password.value, { min: 8 })) {
                errorMsg = 'Password Must be longer then 8 chars';
            }
            if (!validator.matches(this._password.value,
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[#?!@$%^&*-])[A-Za-z\d].{7,}$/, 'i'
            )) {
                if (errorMsg != '')
                    errorMsg += ', ';
                errorMsg += 'Password Must contain at least one: lower case character, upper case character, digit and special character (#?!@$%^&*-)';
            }
        }

        if (errorMsg == "") {
            this
                ._submit
                .click();
        }
        else {
            this.setState({ errorMsg: errorMsg });
        }
    }

    render() {
        return (
            <div className='loginBackground'>
                <div className='loginContainer'>
                    <Form horizontal method="post" autoComplete="off" onSubmit={this.submitForm}>
                        <div className='loginHeader'>
                            <div className='loginLogo'></div>
                            <h3 style={{ margin: '80px 40px 0px 110px' }}>Update Password</h3>
                            <div className='loginFormContainer' style={{ marginTop: '110px' }}>

                                <FormGroup>
                                    <input type="password" placeholder="New password" name="Password" id="Password" ref={(password) => { this._password = password; }} className="form-control" />
                                </FormGroup>

                                <FormGroup>
                                    <input type="password" placeholder="Confirm password" name="ConfirmPassword" id="ConfirmPassword" className="form-control" ref={(password) => { this._confirm_password = password; }} />
                                </FormGroup>

                                <FormGroup>
                                    <label className="error">{this.state.errorMsg}</label>
                                </FormGroup>
                            </div>
                        </div>
                        <input
                            type='submit'
                            className='hidden'
                            ref={(submit) => {
                                this._submit = submit;
                            }} />
                        <label className='submit' onClick={this.submitForm}>UPDATE</label>
                    </Form>
                </div>
            </div>
        )
    }
};

module.exports = loginForm;


// WEBPACK FOOTER //
// ./modules/updatePassword.jsx